import { LabelCoins } from '@/components/custom';
import { cn } from '@/lib/utils';

type TProps = {
	/* in coins, absent means free */
	price?: number;
	className?: string;
};

const EventPrice = ({ price, className }: TProps) =>
	price ? (
		<LabelCoins coins={price} className={className} />
	) : (
		<span className={cn('text-sm text-muted-foreground', className)}>Gratuit</span>
	);

export default EventPrice;
